export const footer = {
    type: "nested",
    label: "Footer Config",
    fields: {
        preventFooter: {
            type: "boolean",
            label: "Prevent Footer"
        },
        footerBg: {
            type: "colorPicker",
            label: "Footer Background",
            possibleColors: [
                "snow"
            ]
        },
        footerTextColor: {
            type: "colorPicker",
            label: "Footer Text Color",
            possibleColors: [
                "black"
            ]
        }
    }
};
